"use client";

import { useState } from 'react';

export default function TechnologyDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE TECHNOLOGY DASHBOARD',
      subtitle: 'Technology Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Executive Technology Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'ARR', value: '₹647Cr', sub: '+18.4% YoY', color: '#1B2845' },
            { x: 186, label: 'Product Adoption Rate', value: '73%', sub: '+5.2% vs LY', color: '#16a34a' },
            { x: 356, label: 'Platform Uptime', value: '99.8%', sub: 'SLA: 99.5%', color: '#C5A572' },
            { x: 526, label: 'NRR', value: '118%', sub: 'Best-in-class', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Product Revenue Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Product Revenue Trend (₹Cr ARR)</text>
          <polyline points="40,290 80,278 120,268 160,255 200,260 240,242 280,232 320,220 360,210 400,198 420,192" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 80,278 120,268 160,255 200,260 240,242 280,232 320,220 360,210 400,198 420,192 420,310 40,310 Z" fill="#1B2845" opacity="0.05" />
          {[40,80,120,160,200,240,280,320,360,400,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,278,268,255,260,242,232,220,210,198,192]?.[i]} r="3" fill="#C5A572" />
          ))}
          {['Q1','Q2','Q3','Q4','Q1','Q2','Q3','Q4','Q1','Q2','Q3']?.map((q, i) => (
            <text key={i} x={[40,80,120,160,200,240,280,320,360,400,420]?.[i] - 6} y="308" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{q}</text>
          ))}

          {/* Subscription Tier Donut */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Subscription Analytics</text>
          <circle cx="530" cy="230" r="45" fill="none" stroke="#1B2845" strokeWidth="18" strokeDasharray="85 198" strokeDashoffset="0" />
          <circle cx="530" cy="230" r="45" fill="none" stroke="#C5A572" strokeWidth="18" strokeDasharray="113 170" strokeDashoffset="-85" />
          <circle cx="530" cy="230" r="45" fill="none" stroke="#3b82f6" strokeWidth="18" strokeDasharray="85 198" strokeDashoffset="-198" />
          <text x="530" y="226" textAnchor="middle" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Tiers</text>
          <text x="530" y="240" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Mix</text>
          {[
            { color: '#1B2845', label: 'Enterprise', pct: '30%' },
            { color: '#C5A572', label: 'Growth', pct: '40%' },
            { color: '#3b82f6', label: 'Starter', pct: '30%' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="590" y={170 + i * 24} width="10" height="10" rx="2" fill={item?.color} />
              <text x="604" y={180 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.label}: {item?.pct}</text>
            </g>
          ))}

          {/* Customer Growth MoM */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Customer Growth MoM</text>
          {[
            { month: 'Aug', count: 420, color: '#1B2845' },
            { month: 'Sep', count: 468, color: '#C5A572' },
            { month: 'Oct', count: 512, color: '#3b82f6' },
            { month: 'Nov', count: 548, color: '#10b981' },
            { month: 'Dec', count: 590, color: '#8b5cf6' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x={28 + i * 130} y="362" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.month}</text>
              <rect x={28 + i * 130} y="366" width={bar?.count * 0.22} height="12" fill={bar?.color} rx="2" opacity="0.8" />
              <text x={34 + i * 130} y="376" fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">+{bar?.count}</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'PRODUCT ANALYTICS DASHBOARD',
      subtitle: 'Product Usage & Feature Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Product Analytics Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'DAU/MAU Ratio', value: '0.42', sub: '+0.06 vs LY', color: '#16a34a' },
            { x: 186, label: 'Feature Adoption', value: '73%', sub: 'Top 10 features', color: '#1B2845' },
            { x: 356, label: 'Avg Session Duration', value: '24.6 min', sub: '+3.2 min MoM', color: '#C5A572' },
            { x: 526, label: 'Monthly Active Users', value: '284K', sub: '+12.4% MoM', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Feature Adoption Rates */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Feature Adoption Rate — Top 10 Features (%)</text>
          {[
            { feat: 'Dashboard', rate: 92, color: '#1B2845' },
            { feat: 'Analytics', rate: 84, color: '#C5A572' },
            { feat: 'Reports', rate: 78, color: '#3b82f6' },
            { feat: 'API Access', rate: 68, color: '#8b5cf6' },
            { feat: 'Integrations', rate: 62, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="28" y={178 + i * 26} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.feat}</text>
              <rect x="110" y={166 + i * 26} width={item?.rate * 2.8} height="14" fill={item?.color} rx="2" opacity="0.75" />
              <text x="116" y={177 + i * 26} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{item?.rate}%</text>
            </g>
          ))}

          {/* User Engagement Trend */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">User Engagement Trend</text>
          <polyline points="460,290 490,278 520,268 550,255 580,260 610,242 640,235 668,228" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="460,290 490,278 520,268 550,255 580,260 610,242 640,235 668,228 668,310 460,310 Z" fill="#C5A572" opacity="0.06" />
          {[460,490,520,550,580,610,640,668]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,278,268,255,260,242,235,228]?.[i]} r="3" fill="#1B2845" />
          ))}

          {/* Customer Segmentation */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Customer Segmentation by Tier</text>
          {[
            { seg: 'Enterprise', count: 284, rev: '₹420Cr', color: '#1B2845', bg: '#f0f4ff' },
            { seg: 'Mid-market', count: 1840, rev: '₹165Cr', color: '#C5A572', bg: '#fefce8' },
            { seg: 'SMB', count: 12400, rev: '₹62Cr', color: '#3b82f6', bg: '#eff6ff' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x={28 + i * 220} y="352" width="200" height="44" rx="6" fill={item?.bg} />
              <text x={38 + i * 220} y="368" fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.seg}: {item?.count} customers</text>
              <text x={38 + i * 220} y="384" fill={item?.color} fontSize="12" fontWeight="bold" fontFamily="sans-serif">{item?.rev} ARR</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'PLATFORM PERFORMANCE DASHBOARD',
      subtitle: 'Infrastructure & Engineering Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Platform Performance Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'System Uptime', value: '99.8%', sub: 'SLA: 99.5%', color: '#16a34a' },
            { x: 186, label: 'Avg Response Time', value: '142ms', sub: '↓ 28ms MoM', color: '#1B2845' },
            { x: 356, label: 'Daily Deploys', value: '24', sub: '+8 vs LY', color: '#C5A572' },
            { x: 526, label: 'Open Incidents', value: '3', sub: '0 P1, 1 P2', color: '#d97706' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Infrastructure Utilization */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Infrastructure Utilization by Service (%)</text>
          {[
            { svc: 'API Gateway', util: 72, color: '#1B2845' },
            { svc: 'Auth Service', util: 58, color: '#C5A572' },
            { svc: 'Data Pipeline', util: 84, color: '#d97706' },
            { svc: 'ML Models', util: 91, color: '#dc2626' },
            { svc: 'CDN', util: 45, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="28" y={178 + i * 26} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.svc}</text>
              <rect x="120" y={166 + i * 26} width={item?.util * 2.8} height="14" fill={item?.color} rx="2" opacity="0.75" />
              <text x="126" y={177 + i * 26} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{item?.util}%</text>
            </g>
          ))}

          {/* Incident Tracking */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Incident Tracking</text>
          {[
            { inc: 'Auth timeout — P2', sev: 'P2', color: '#d97706', bg: '#fffbeb', time: '2h ago' },
            { inc: 'API latency spike — P3', sev: 'P3', color: '#C5A572', bg: '#fefce8', time: '4h ago' },
            { inc: 'DB slow query — P3', sev: 'P3', color: '#C5A572', bg: '#fefce8', time: '6h ago' },
            { inc: 'CDN cache miss — P4', sev: 'P4', color: '#16a34a', bg: '#f0fdf4', time: '8h ago' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="460" y={163 + i * 30} width="210" height="24" rx="4" fill={item?.bg} />
              <text x="470" y={178 + i * 30} fill="#374151" fontSize="8" fontFamily="sans-serif">{item?.inc}</text>
              <text x="620" y={178 + i * 30} fill={item?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.sev}</text>
            </g>
          ))}

          {/* Deployment Frequency */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Deployment Frequency — Daily Deploys Trend</text>
          <polyline points="40,380 100,372 160,368 220,360 280,355 340,348 400,342 460,338 520,332 580,326 640,320 668,316" fill="none" stroke="#C5A572" strokeWidth="2" strokeLinecap="round" />
          {[40,100,160,220,280,340,400,460,520,580,640,668]?.map((x, i) => (
            <circle key={i} cx={x} cy={[380,372,368,360,355,348,342,338,332,326,320,316]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']?.map((m, i) => (
            <text key={i} x={[40,100,160,220,280,340,400,460,520,580,640,668]?.[i] - 6} y="396" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Technology Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every level of technology leadership.</p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d?.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.subtitle}</h3>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
